import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DateService } from 'src/app/services/date.service';
import { VmsService } from 'src/app/services/vms.service';

@Component({
  standalone: false,
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.scss']
})
export class RequestDetailsComponent implements OnInit ,OnDestroy{

  id: any;
  fullName: string;
  mobileNumber: any;
  emailId: any;
  date: any;
  time: any;
  buildingName: string;
  floor: number;
  guestList: any;
  tempDate: any;
  approved: boolean = true;
  fromHistory: boolean;
  type: any;
  individualInvite: boolean;
  data: any;
  private subscriptions = new Subscription();
  tempData: any;
  individualInviteRoute: string;

  constructor(
    private vmsSrv: VmsService,
    private activatedRoute: ActivatedRoute,
    private dateSrv: DateService
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem('navigate') == '2') this.fromHistory = true;
    if (localStorage.getItem('navigate') == '1') this.fromHistory = false;
    this.activatedRoute.queryParams.subscribe((res) => {
      this.id = res.id ? res.id : null;
      this.individualInvite = res?.type == 'individual' ? true : false;
      this.individualInviteRoute= res?.type == 'individual' ? 'individual-invite': 'bulk-invite';
      // this.loadData(this.id);
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadData(id) {
    const data = {
      InvitationID: id,
    };
    this.subscriptions.add(this.vmsSrv.getInvitationDetail(data).subscribe((res) => {
      console.log(res);
      this.data=res;
      this.tempData=this.data;
      this.approved = res.isApproved;
    }))
  }

  formatDate(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(
        this.tempDate[2],
        this.tempDate[1],
        this.tempDate[0]
      );
    }
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':');
      console.log(this.tempDate);
      return this.tempDate[0] + ':' + this.tempDate[1];
    }
  }



  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  deleteSelected(inviteData, i) {
    // this.tempData.t0600Vmsguests.forEach((element,index)=> {
    //   console.log(element)
    //   if(element.guestId==inviteData){
    //     console.log("im in")
    //     this.tempData.splice(index,1)
    //     this.loadData(this.id);
    //   }
    // });
  }

  cancelInvite(id){
    this.subscriptions.add(this.vmsSrv.cancelInvitation(id).subscribe(res=>{
      console.log(res)
    }))
  }
}
